<template>
<footer>
    <div class="footter pt-4 pb-5">
        <div class="container">
            <div class="row row-s">
                <div class="col-xs-12 col-md-6 col-s">
                    <div class="item"> 
                        <h3 class="hidden-xs">Về chúng tôi</h3> 
                        <p class="company-name">CÔNG TY TNHH ĐẦU TƯ THƯƠNG MẠI BẢO GIA PHÚ</p>
                        <p>Địa chỉ: 1331/15/69 Lê Đức Thọ, P. 14, Q. Gò Vấp, Tp. Hồ Chí Minh</p>
                        <p>Hotline: <span >09 1889 4567</span></p> 
                        <p>Email: <a href="kinhdoanhocvit@gmail.com"><span >kinhdoanhocvit@gmail.com</span></a></p>                    
                        <p>Website: <a href="thanhren.vn"><span >thanhren.vn</span></a></p>                    
                                          
                    </div>
                </div>
                <div class="col-xs-12 col-md-3 col-s">
                    <div class="item">
                        <h3 >Liên kết</h3>
                            <ul >
                                <li class="nav-item active">            	
                                    <router-link class="nav-link " exact :to="{ name: 'home' }"><i class="fa fa-caret-right" aria-hidden="true"></i>Trang chủ</router-link>
                                </li>
                                <li class="nav-item">
                                    <router-link class="nav-link " exact  :to="{ name: 'introduce', params: { slug: 'gioi-thieu' } }"><i class="fa fa-caret-right" aria-hidden="true"></i>Giới thiệu</router-link>
                                </li>
                                <li><a href="/san-pham" title="Sản Phẩm"><i class="fa fa-caret-right" aria-hidden="true"></i>Sản Phẩm</a></li>
                                <li class="nav-item">
                                    <router-link class="nav-link " exact  :to="{  name: 'news-list',  params: { slug: 'tin-tuc' }}"><i class="fa fa-caret-right" aria-hidden="true"></i>Tin tức</router-link>
                                </li>
                                <li class="nav-item">
                                    <router-link class="nav-link" exact :to="{  name: 'contact',  params: { slug: 'lien-he' }}"><i class="fa fa-caret-right" aria-hidden="true"></i>Liên hệ</router-link>
                                </li>
                            </ul>
                    </div>
                </div>                    
                <div class="col-xs-12 col-md-3 col-s">
                    <div class="item">
                        <h3 >Dịch vụ khách hàng</h3>
                            <ul >
                                <li class="nav-item">
                                    <router-link class="nav-link " exact  :to="{  name: 'page', params: { slug: 'huong-dan-mua-hang' }}"><i class="fa fa-caret-right" aria-hidden="true"></i>Hướng dẫn mua hàng</router-link>
                                </li>
                                <li class="nav-item">
                                    <router-link class="nav-link " exact  :to="{  name: 'page', params: { slug: 'huong-dan-thanh-toan' }}"><i class="fa fa-caret-right" aria-hidden="true"></i>Hướng dẫn thanh toán</router-link>
                                </li>
                            </ul>
                            <div class="log">
                                <ul class="list-menu social-media-footer has-toggle">
                                    <li><a href="#" target="_blank" title="facebook"><i class="fa fa-facebook"></i></a></li>
                                    <li><a href="#" title="twitter"><i class="fa fa-twitter"></i></a></li>
                                    <li><a href="#" title="pinterest"><i class="fa fa-pinterest"></i></a></li>
                                    <li><a href="#" title="instagram"><i class="fa fa-instagram"></i></a></li>
                                    <li><a href="https://www.youtube.com/" title="youtube"><i class="fa fa-youtube"></i></a></li>
                                </ul>
                            </div>  
                    </div>
                        
                </div>                        

            </div>
            <div class="bottom">
                <div class="row">
                    <div class="col-xs-12 col-sm-6">
                        <p>Copyright @ 2019 Bảo Gia Phú  - All right</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</footer>
</template>

<script>
export default {
  name: "RwvFooter"
};
</script>
